import { managedPageQueryMeta, throwIfResponseNotOk } from '@/queries/queryErrorHandling';
import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import { Reserve, Reserves } from '@/types/Reserves';
import { QueryFunction, useQuery } from '@tanstack/react-query';

/** Haalt het reserve-overzicht op via GET /werklijnen/reserves (reserves v2).
 *
 * In tegenstelling tot de oude /werklijnen/zoek variant bevat dit ook stellen die nu nog niet
 * inzetbaar (defect) zijn, maar op basis van de geplande verwacht_gereed tijd van dat defect
 * binnenkort (AANKOMEND) of al te laat (ACHTERSTALLIG) weer reserve zouden moeten worden.
 */
const useGetReservesV2 = (enabled = true) => {
  const { fetchWithAuth } = useFetchWithAuth();

  const fetcher: QueryFunction<Reserve[]> = async ({ signal }) => {
    const response = await fetchWithAuth('/werklijnen/reserves', { signal });
    throwIfResponseNotOk(response, `Ophalen van reserves is mislukt (${response.status}).`);
    const data: Reserves = await response.json();
    return data?.reserves ?? [];
  };

  return useQuery({
    queryKey: ['reservesVanafNu', 'v2'],
    queryFn: fetcher,
    refetchInterval: 10_000,
    enabled,
    meta: managedPageQueryMeta,
  });
};
export default useGetReservesV2;
